<div class="section-container" *ngIf="hasModifierGroups()">
  <ng-container *ngFor="let mod of modifierGroupsFormGroups">
    <div [formGroup]="mod" class="modifier-group">
      
      <div class="modifier-header">
        <h3 class="section-title">
          {{ getModifierGroupsValueByFormGroup(mod)?.grupoModificador?.nombre || 'Ingredients' }}
        </h3>
        <div class="badges">
          <span class="badge" [ngClass]="getMinimumBadgeClass(mod)">
            Minimum {{ getModifierGroupsValueByFormGroup(mod)?.grupoModificador?.minimo }}
          </span>
          <span class="badge" [ngClass]="getMaximumBadgeClass(mod)">
            Maximum {{ getModifierGroupsValueByFormGroup(mod)?.grupoModificador?.maximo ?? 0 }}
          </span>
        </div>
      </div>
      
      <div class="modifier-table-container">
        <table class="modifier-table">
          <thead>
            <tr>
              <th class="col-name">{{ translations['name'] }}</th>
              <th class="col-center col-no">{{ translations['no'] }}</th>
              <th class="col-center col-add">{{ translations['add'] }}</th>
              <th class="col-center col-extra">{{ translations['extra'] }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let modDet of getModifierGroupDetailsAsFormGroup(mod)">
              <tr [formGroup]="modDet">
                <td class="col-name">
                  {{ getModifierGroupDetailByFormGroup(modDet)?.modificador?.nombre }}
                </td>
                
                <td class="col-center col-no">
                  <div class="no-cell">
                    <label class="custom-checkbox-wrapper">
                      <input type="checkbox"
                        class="custom-checkbox"
                        (change)="onNoAddChange($event, modDet)"
                        [checked]="getModifierGroupDetailByFormGroup(modDet)?.noAdd"
                      >
                      <span class="checkbox-box"></span>
                    </label>
                    <span class="price-info invisible">{{ translations['free'] }}</span>
                  </div>
                </td>
                
                <td class="col-center col-add">
                  <div class="add-cell">
                    <label class="custom-checkbox-wrapper">
                      <input type="checkbox"
                        class="custom-checkbox"
                        (change)="onAddExtraChange($event, modDet, mod)"
                        [checked]="getModifierGroupDetailByFormGroup(modDet)?.addExtra"
                        [disabled]="isModifierSelectionDisabled(modDet, mod)"
                      >
                      <span class="checkbox-box"></span>
                    </label>
                    <span class="price-info" *ngIf="shouldShowModifierBasePrice(modDet)">
                      {{ getModifierGroupDetailByFormGroup(modDet)?.precioBase | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
                    </span>
                    <span class="price-info text-success" *ngIf="shouldShowFreeModifierLabel(modDet)">{{ translations['free'] }}</span>
                  </div>
                </td>
                
                <td class="col-center col-extra">
                  <div class="extra-cell">
                    <div class="controls-wrapper">
                      <div class="qty-btn"
                           (click)="decreaseDetail(modDet)"
                           [class.disabled]="isModifierDecreaseDisabled(modDet)">
                        <app-icon iconName="minus" size="12"></app-icon>
                      </div>
                      <span class="qty-val">{{ getModifierGroupDetailByFormGroup(modDet)?.cantidad || 0 }}</span>
                      <div class="qty-btn btn-plus"
                           (click)="increaseDetail(modDet)"
                           [class.disabled]="isModifierIncreaseDisabled(modDet)">
                        <app-icon iconName="plus" color="white" size="12"></app-icon>
                      </div>
                    </div>
                    <div class="price-wrapper">
                      <span class="extra-price" [class.invisible]="shouldHideExtraPrice(modDet)">
                        +{{ getModifierGroupDetailByFormGroup(modDet)?.precio | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
